module.exports = __webpack_public_path__ + "img/anrei.l__600x600.32785dc9.jpg";